"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var CalendarSlider_1 = __importDefault(require("containers/Onboarding/TransactionPopup/CalendarSlider"));
var MonthSummary_1 = require("containers/Onboarding/TransactionPopup/MonthSummary");
var SliderItem_1 = __importDefault(require("shared/components/Slider/SliderItem"));
var Text_1 = __importDefault(require("shared/components/Text"));
var dateTime_1 = require("utils/dateTime");
var constants_1 = require("./constants");
var SpendGraphAxis_1 = __importDefault(require("./SpendGraphAxis"));
var CssBarLine_1 = __importDefault(require("./styles/CssBarLine"));
var PREFIX = 'SpendBarGraph';
var classes = {
    sliderItemWrapper: "".concat(PREFIX, "-sliderItemWrapper"),
    sliderItem: "".concat(PREFIX, "-sliderItem"),
    labelText: "".concat(PREFIX, "-labelText"),
    graph: "".concat(PREFIX, "-graph"),
    bars: "".concat(PREFIX, "-bars"),
    monthLabels: "".concat(PREFIX, "-monthLabels"),
    barTypography: "".concat(PREFIX, "-barTypography"),
    selected: "".concat(PREFIX, "-selected"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.sliderItemWrapper)] = {
            padding: theme.spacing(0, 1.5),
            '&:first-child': {
                marginLeft: 0,
            },
            '&:last-child': {
                marginRight: 0,
            },
        },
        _b[".".concat(classes.sliderItem)] = {
            display: 'flex',
            justifyContent: 'flex-end',
            minWidth: 24,
            minHeight: 78,
        },
        _b[".".concat(classes.labelText)] = {
            fontSize: 12,
            textTransform: 'uppercase',
        },
        _b["&.".concat(classes.graph)] = {
            margin: theme.spacing(2, 0),
            position: 'relative',
            height: 200,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
        },
        _b[".".concat(classes.bars)] = {
            position: 'absolute',
            width: '100%',
            zIndex: 10,
            cursor: 'pointer',
            marginBottom: theme.spacing(0.75),
            height: '100%',
            border: 0,
            borderBottom: '9px solid transparent',
        },
        _b[".".concat(classes.monthLabels)] = {
            textTransform: 'uppercase',
        },
        _b[".".concat(classes.barTypography)] = {
            fontWeight: theme.typography.fontWeightLight,
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.selected)] = {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
        },
        _b);
});
var SpendBarGraph = function (_a) {
    var toolStats = _a.toolStats, onMonthClick = _a.onMonthClick, selectedMonth = _a.selectedMonth;
    var monthlyExpenditureHistory = (0, MonthSummary_1.getMonthlyExpenditureHistory)(toolStats.expenditures);
    var maxSpend = monthlyExpenditureHistory.length > 0
        ? Math.round(Math.max.apply(Math, __spreadArray([], __read(monthlyExpenditureHistory.map(function (m) { return m.spend; })), false))) : 10000;
    var selectedMonthIdx = monthlyExpenditureHistory.findIndex(function (m) { return (0, isEqual_1.default)(m.yM, selectedMonth); });
    var monthsData = monthlyExpenditureHistory.length > 0 ? monthlyExpenditureHistory : constants_1.DUMMY_MONTHS;
    var powScale = (Math.pow(10, (Math.ceil(Math.log10(maxSpend / 3)) - 1))) || 1;
    var scale = powScale * Math.round((maxSpend / 3) / powScale);
    var percentage = (maxSpend - (3 * scale)) / scale;
    var steps = percentage > 0.3333 ? 4 : 3;
    var maxScale = scale * steps;
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ className: classes.graph }, { children: [(0, jsx_runtime_1.jsx)(CalendarSlider_1.default, __assign({ value: selectedMonthIdx !== -1 ? selectedMonthIdx : monthsData.length - 1, className: classes.bars, component: "dl" }, { children: monthsData.map(function (m) {
                    var key = (0, dateTime_1.getYMKey)(m.yM);
                    var isSelected = (0, isEqual_1.default)(m.yM, selectedMonth);
                    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, className: classes.sliderItemWrapper, onClick: function () { return onMonthClick(m.yM); } }, { children: [(0, jsx_runtime_1.jsx)(SliderItem_1.default, __assign({ component: "dd", className: classes.sliderItem }, { children: (0, jsx_runtime_1.jsx)(CssBarLine_1.default, { spend: m.spend, maxScale: maxScale, steps: steps, isSelected: isSelected }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", justifyContent: "center", flexDirection: "column", mt: 1 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", className: (0, clsx_1.default)(isSelected ? classes.selected : classes.barTypography, classes.monthLabels) }, { children: m.label })) }))] }), key));
                }) })), (0, jsx_runtime_1.jsx)(SpendGraphAxis_1.default, { maxSpend: maxSpend, scale: scale })] })));
};
exports.default = SpendBarGraph;
